var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kn-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"fullWidth":true,"tableTitle":"Inventario","newButtonLabel":"Agregar inventario","disableBtnCreate":!_vm.canAdd('inventario'),"paginationCount":_vm.pagination.lastPage,"hideDefaultFooter":true,"loading":_vm.loading},on:{"onChangePage":_vm.changePageInventory}})
}
var staticRenderFns = []

export { render, staticRenderFns }